import { Component } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/services/google-analytics/google-tag-manager.service';
import { ModalService } from 'src/app/services/modal-service/modal.service';
import * as strings from './driver-licence-modal.component.strings';
import { BaseModalComponent } from '../base-modal/base-modal.component';

@Component({
    selector: 'app-driver-licence-modal',
    templateUrl: './driver-licence-modal.component.html',
    styleUrl: './driver-licence-modal.component.scss',
    imports: [BaseModalComponent]
})
export class DriverLicenceModalComponent {
    public s = strings;
    
    constructor(private modalService: ModalService,
        private googleTagManagerService: GoogleTagManagerService) {
            this.triggerGtmEvent('pop_up', 'open', 'driver_licence_pop_up');
    }

    closeCalcModal(){
        this.modalService.dismissAll();
    }

    triggerGtmEvent(event: string, action: string, html_id: string){
        this.googleTagManagerService.trackAction({
            event: event,
            action: action,
            html_id: html_id,
            name: html_id
        });
    }
}
